import {EnableSidebar, PageTitle} from '../../../_metronic/layout/core'
import {useEffect, useState} from 'react'
import {
  ListsWidget4,
  ListsWidget5,
  TablesWidget9,
  MixedWidget13,
  MixedWidget14,
  MixedWidget15,
} from '../../../_metronic/partials/widgets'
import {Vertical} from '../../modules/wizards/components/Vertical'
import {getAnnouncements} from '../announcement/list/core/_requests'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {
  downloadAcceptanceLetterAsStudent,
  getIsAcceptanceLetterButtonVisible,
} from '../applicationuser/list/core/_requests'
import Swal from 'sweetalert2'

const DashboardPage = () => {
  const [announcements, setAnnouncements] = useState([])
  const [isDownloadingEbys, setIsDownloadingEbys] = useState(false)
  const [isAcceptanceLetterButtonVisible, setIsAcceptanceLetterButtonVisible] = useState<
    boolean | null
  >(null)
  const lang = useLang()
  const intl = useIntl()

  useEffect(() => {
    getAnnouncements().then((a: any) => {
      const activeAnnouncements = a.data?.data?.filter((k: any) => k.isActiveDashboard) || []
      setAnnouncements(activeAnnouncements)
    })

    getIsAcceptanceLetterButtonVisible()
      .then((res) => {
        setIsAcceptanceLetterButtonVisible(res)
      })
      .catch(() => {
        setIsAcceptanceLetterButtonVisible(false)
      })
  }, [])

  const handleDownloadEbys = async () => {
    try {
      setIsDownloadingEbys(true)

      const blobData = await downloadAcceptanceLetterAsStudent()

      // Backend hata döndüyse Blob içerisindeki JSON'u oku
      if (blobData.type === 'application/json') {
        const errorText = await blobData.text()
        const errorJson = JSON.parse(errorText)

        throw new Error(errorJson.message ?? errorJson.Message ?? 'Belge indirilirken hata oluştu.')
      }

      const blob = new Blob([blobData], {type: 'application/pdf'})
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = 'EBYS_Kabul_Mektubu.pdf'

      document.body.appendChild(link)
      link.click()

      link.remove()
      window.URL.revokeObjectURL(url)

      Swal.fire({
        icon: 'success',
        title: 'Başarılı!',
        text: 'EBYS Belgesi başarıyla indirildi.',
        confirmButtonText: 'Tamam',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    } catch (error: any) {
      console.error(error)

      let errorMessage = 'Belge indirilirken beklenmeyen bir hata oluştu.'

      if (error.response?.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text()
          const errorJson = JSON.parse(errorText)
          errorMessage = errorJson.message ?? errorJson.Message ?? errorText
        } catch {
          errorMessage = 'Hata mesajı çözümlenemedi.'
        }
      } else if (error.message) {
        errorMessage = error.message
      }

      Swal.fire({
        icon: 'error',
        title: 'Hata Oluştu!',
        text: errorMessage,
        confirmButtonText: 'Tamam',
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    } finally {
      setIsDownloadingEbys(false)
    }
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Dashboard'})}</PageTitle>
      <div className='d-flex w-100 gap-5 pb-5'>
        <Link className='btn btn-success' to='/preference'>
          {intl.formatMessage({id: 'MENU.PREFERENCE'})}
        </Link>
        <Link className='btn btn-primary' to='/myplacement'>
          {intl.formatMessage({id: 'MENU.MYPLACEMENT'})}
        </Link>
      </div>

      {/* {announcements.map((a: any) => {
        return (lang === "tr" ? <div className="alert alert-primary mt-5">{a.text}</div>
          : <div className="alert alert-primary mt-5">{a.textEn}</div>
        )
      })} */}
      {announcements.map((a: any, index: number) => {
        const text = lang === 'tr' ? a.text : a.textEn

        return (
          <div
            key={index}
            className='alert alert-primary mt-5'
            dangerouslySetInnerHTML={{__html: text}}
          />
        )
      })}
      <br></br>
      <br></br>
      {isAcceptanceLetterButtonVisible === true && (
        <div
          className='card'
          style={{
            backgroundColor: '#dee2e6',
            width: '320px',
          }}
        >
          <div className='card-body'>
            <h5 className='card-title'>{intl.formatMessage({id: 'Kabul Mektubu İşlemleri'})}</h5>
            <br></br>
            <button
              className='btn btn-primary'
              onClick={handleDownloadEbys}
              disabled={isDownloadingEbys}
            >
              {isDownloadingEbys ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2'></span>
                  Belge İndiriliyor...
                </>
              ) : (
                'Kabul Mektubu İndir'
              )}
            </button>
          </div>
        </div>
      )}
    </>
  )
}

const DashboardWrapper = () => {
  return (
    <EnableSidebar>
      <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
      <div className='card-xl-stretch mb-5 mb-xl-10'>
        <Vertical />
      </div>
    </EnableSidebar>
  )
}

export {DashboardPage}
